import 'magnific-popup';
import 'lazysizes';
import 'selectric';
import 'icheck';

import './base/';
import './sliders';
import './recently-view';
import './accordion';
import './navigation';
import './filter';
import './product-effect';
import './register';
import './cart';
import './checkout';
import './product';
import './contact';
import './popup';
import './upload-file';

import { animate } from './animate';

// import { isTouchDevice } from './detect-touch-device';
import { swapImage } from './swap-image';

const $win = $(window);
const $doc = $(document);
const $header = $('.header');

function initAnimate() {
	let winST = $win.scrollTop();
	animate(winST);
}

$('select:not([name="id"])').selectric();

swapImage($('.slider__slide-image'));

initAnimate();

$doc.on('click', '.link-fade', function(e) {
	e.preventDefault();

	const $this = $(this);

	$this.closest('.section__inner-fade').removeClass('section__inner-fade');

	$this.remove();
});

if ($('.section-account').length) {
	const $activeLink = $('.section-account .section__nav li.active');

	if ($activeLink.offset().left > 0) {
		$('.section-account .section__nav > ul').scrollLeft($activeLink.offset().left - 20);
	}
}

$win
	.on('load scroll', function() {
		initAnimate();
	})
	.on('resize', function() {
		swapImage($('.slider__slide-image'));
	});



// WEBPACK FOOTER //
// ../assets/js/main.js